export const normalizeInputChangeEvent = (e: React.ChangeEvent<HTMLInputElement>) => {
  const normalizedEvent = { ...e, target: { ...e.target, value: e.target.value.normalize() } };

  return normalizedEvent;
};
